import {InjectionToken} from '@angular/core';

export const WEB_ID_ENABLED = new InjectionToken<boolean>('WEB_ID_ENABLED');
